import { redirect } from "@client/actions";
import { type RootContainerProps } from "@client/content/types";
import { globals } from "@client/globals";
import { getCart } from "@client/lib/cookie";
import { connectCustom } from "@client/lib/misc";
import { makeMarginStyleSelector, TargetSelector } from "@client/selectors";
import { type AppState, type EnhanceWidget } from "@client/types";
import classNames from "classnames";
import { identity } from "lodash";
import Component, { type ActionProps, type MapProps } from "./component";
import { floatingMenuVisibilitySelector, makeElementsSelector, positionSelector, styleSelector } from "./selectors";

export type FloatingMenuContainerProps = Omit<RootContainerProps, "id" | "source" | "StaticContainer"> & {
  enhance?: EnhanceWidget;
  onDoubleClick?: () => void;
};
const makeMapStateToProps = () => {
  const marginStyleSelector = makeMarginStyleSelector(TargetSelector.Layout, "floatingMenu");
  const elementsSelector = makeElementsSelector();

  return (state: AppState, props: FloatingMenuContainerProps): MapProps => {
    const visibility = floatingMenuVisibilitySelector(state);

    const elements = elementsSelector(state) ?? [];

    const cart = getCart(state.portal.id);
    return {
      ...props,
      cartItemCount: cart ? cart.items?.reduce((res, x) => res + x.quantity, 0) ?? 0 : 0,
      StaticContainer: identity,
      className: classNames(positionSelector(state)?.replace(" ", "_")),
      source: "content",
      elements,
      id: "floatingMenu",
      isEditMode: state.isEditMode,
      isVisible: visibility.isVisible && !!elements.length,
      innerStyle: styleSelector(state),
      outerStyle: marginStyleSelector(state)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: FloatingMenuContainerProps): ActionProps => ({
  goToCart: () =>
    dispatch(
      redirect({
        redirectTo: {
          pageId: globals.siteInfo.cartPageId,
          newTab: false,
          type: "tab"
        }
      })
    ),
  onDoubleClick: props.onDoubleClick
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps, {
  forwardRef: true
})(Component);
